import { render, staticRenderFns } from "./cancel-call-icon.vue?vue&type=template&id=805d4b4c"
import script from "./cancel-call-icon.vue?vue&type=script&lang=js"
export * from "./cancel-call-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805d4b4c')) {
      api.createRecord('805d4b4c', component.options)
    } else {
      api.reload('805d4b4c', component.options)
    }
    module.hot.accept("./cancel-call-icon.vue?vue&type=template&id=805d4b4c", function () {
      api.rerender('805d4b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/cancel-call-icon.vue"
export default component.exports